module.exports = __webpack_public_path__ + "img/tier2_pic1.fd699374.png";